class Survey {
    constructor() {
        this.triggerScroll = 200; // 200px scroll minimum
        this.triggerDelay = 3000; // 3 seconds pause when scrolling
        this.triggerImmediate = 2000; // 2 seconds pause when immediate (after dynamic action)
        this.triggerTime = 15000; // 15 seconds timeout when not scrolling
        this.intialScrollPosition = 0;

        this.timeoutHandle = -1;
        this.delayHandle = -1;
        this.surveyElement = null;
        this.pad = 30;
        this.setDelay(0);
        this.setTimeout(0);
        this.triggerQuestion = this.trigger.bind(this);
    }

    configure(type) {
        const cd = new Date();
        const h = cd.getHours();
        if (h >= 8 && h <= 23) {
            this.type = type;

            this.intialScrollPosition = window.scrollY;
            this.setTimeout(this.triggerTime);

            window.addEventListener('scroll', this.triggerQuestion);
        }
    }

    configureImmediate(type) {
        const cd = new Date();
        const h = cd.getHours();
        if (h >= 8 && h <= 23) {
            this.type = type;
            this.setTimeout(this.triggerDelay);
        }
    }

    trigger(event) {
        if (Math.abs(window.scrollY - this.intialScrollPosition) > this.triggerScroll) {
            this.setDelay(this.triggerDelay);
        }
    }

    setDelay(time) {
        window.clearTimeout(this.delayHandle);
        if (time && time > 0) {
            this.delayHandle = window.setTimeout(() => {
                this.present();
            }, time);
        }
    }

    setTimeout(time) {
        window.clearTimeout(this.timeoutHandle);
        if (time && time > 0) {
            this.timeoutHandle = window.setTimeout(() => {
                this.present();
            }, time);
        }
    }

    present() {
        this.setTimeout(0);
        this.setDelay(0);
        window.removeEventListener('scroll', this.triggerQuestion);

        // This will be an ajax request from the back end
        $.getJSON(`/survey/getquestion/${this.type}`, (q, s) => {
            if (s === 'success') {
                this.display(`Private Health Insurance Ombudsman Survey`, 'Your answers will be used by the Ombudsman to improve this website.', 'Please use the feedback link for any other suggestions.', q.QuestionID, q.QuestionText, q.Answers);
            } else {
                console.info(`Survey returned '${s}' (probably threshold).`);
            }
        });
    }

    /**
     *
     * @param {*} heading The heading for the message (optional)
     * @param  {*} question The question to present
     * @param  {...any} answers One or more answers to display
     */
    display(heading, intro, footer, id, question, answers) {
        const m = document.getElementById('survey');
        if (m) {
            document.body.removeChild(m);
        }

        if (!document.getElementById('survey')) {
            const surveyDiv = document.createElement('div');
            surveyDiv.id = 'survey';

            const headingDiv = document.createElement('heading');

            if (question && question.length > 0) {
                const h = document.createElement('h1');
                h.appendChild(document.createTextNode(heading));
                headingDiv.appendChild(h);
            }
			
			const instructionElement = document.createElement('small');
			instructionElement.appendChild(document.createTextNode(intro));
			

            const b = document.createElement('button');
            b.type = 'button';
            b.classList.add('close');
            b.setAttribute('aria-label', 'Close');
            b.title = `Don't answer`;
            b.addEventListener('click', () => {
                setSession('survey-closed', 12 * 60);

                $.ajax(`/survey/dontask/${id}`)
                    .done(() => {
                        console.info(`Survey submit 'don't ask ${id}'`);
                    })
                    .fail(() => {
                        console.error(`Survey submit failed 'don't ask ${id}'`);
                    });

                this.destroy();
            });

            const s = document.createElement('span');
            s.setAttribute('aria-hidden', true);
            s.innerHTML = '&times;';
            b.appendChild(s);
            headingDiv.appendChild(b);

            surveyDiv.appendChild(headingDiv);
			surveyDiv.appendChild(instructionElement);

            const questionDiv = document.createElement('p');
            questionDiv.appendChild(document.createTextNode(question));
            surveyDiv.appendChild(questionDiv);

            if (answers.length > 0) {
                const d = document.createElement('div');
                d.classList.add('answers');

                answers.forEach(answer => {
                    const l = document.createElement('label');

                    const i = document.createElement('input');
                    i.type = 'radio';
                    i.name = 'survey';
                    i.value = answer.AnswerID;
                    i.setAttribute('data-question', id);
                    i.addEventListener('click', e => {
                        const q = e.target.getAttribute('data-question');
                        const v = e.target.getAttribute('value');

                        $.ajax(`/survey/submitanswer/${q}/${v}`)
                            .done(() => {
                                console.info(`Survey submit 'answer ${q}=>${v}'`);
                            })
                            .fail(() => {
                                console.error(`Survey submit failed 'answer ${q}=>${v}'`);
                            });

                        setSession('survey-asked', 10);
                        this.destroy();
                    });

                    l.appendChild(i);
                    l.appendChild(document.createTextNode(answer.AnswerText));
                    d.appendChild(l);
                });

                surveyDiv.appendChild(d);
            }
			
			const footerDiv = document.createElement('small');
			footerDiv.classList.add('float-right');
			footerDiv.appendChild(document.createTextNode(footer));
			surveyDiv.appendChild(footerDiv);

            document.body.appendChild(surveyDiv);

            this.messageElement = surveyDiv;

            const offsetX = '0px';
            const offsetY = '50%';

            surveyDiv.style.cssText = `--desktop-message-offset: ${offsetY}; --desktop-message-x: ${offsetX};`;
        }

        this.messageElement.classList.add('active');
    }

    destroy() {
        const e = this.messageElement;
        this.messageElement = null;

        if (e) {
            e.addEventListener('webkitAnimationEnd', this.remove, false);
            e.addEventListener('animationend', this.remove, false);
            e.addEventListener('oanimationend', this.remove, false);

            e.classList.remove('active');
            e.classList.add('inactive');
        }
    }
}
